import { render } from "./OnboardingPage.vue?vue&type=template&id=267398f6&ts=true"
import script from "./OnboardingPage.vue?vue&type=script&lang=ts"
export * from "./OnboardingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__